import { render, staticRenderFns } from "./JobRuns.vue?vue&type=template&id=33c89a9c"
import script from "./JobRuns.vue?vue&type=script&lang=js"
export * from "./JobRuns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports